import React, { useState } from 'react';


function Footer() {
  return (
    <>
        <footer className="footer" id="footer">
            <div className="footer__content container">
                <div className="footer__column">
                <div className="footer__copy">
                    © Сеть детских развивающих центров «TopKids», 2005-
                    <span className="footer__copy-this-year">{new Date().getFullYear()}</span>г.
                </div>
                <p className="footer__info">
                    ИП Швейкус Галина Валентиновна, <br />
                    ИНН 280100993246
                </p>
                <address className="footer__address">
                    Россия, Амурская обл., г. Благовещенск
                </address>
                </div>
                <div className="footer__column">
                <ul
                    className="footer__social social list-reset"
                    title="Социальные сети"
                >
                    <li className="social__item">
                    <a
                        href="https://www.youtube.com/channel/UCFPKDP-mH1FFTakJabS8taw"
                        target="_blank"
                        className="social__link social__link--ytb"
                        aria-label="Наш канал в ютубе"
                    ></a>
                    </li>
                </ul>
                <button
                    data-hystmodal="#policy"
                    className="footer__politics btn-reset"
                >
                    Политика конфиденциальности{" "}
                </button>
                </div>
                <div className="footer__column">
                <div className="contacts-box contacts-box--footer footer__contacts">
                    <a href="tel:+79145866771" className="contacts-box__tel">
                    +7 914 586 67 71
                    </a>
                    <button
                    data-hystmodal="#order-call"
                    className="contacts-box__callback btn-reset"
                    >
                    Заказать звонок
                    </button>
                </div>
                </div>
            </div>
        </footer>
    </>
  );
}

export default Footer;
